import bindTable from './bindTable'
export default function () {
  const bindtb = bindTable.call(this)
  // 添加停用时间
  bindtb.splice(4, 0, {
    title: $t('integration.down_time_'),
    index: 'stop_time',
    format: 'datetime'
  })

  // 替换操作
  bindtb.splice(6, 1, {
    title: $t('integration.operation'),
    operation: [
      {
        type: 'edit',
        title: $t('integration.modify_customer'),
        click: this.editScopeRowFn
      },
      {
        type: 'delete',
        tip: true,
        click: this.delRowFn
      },
      {
        type: 'reuse',
        tip: true,
        click: this.useAgainRowFn
      },
      {
        type: 'detail',
        click: this.detailFn
      }
    ]
  })
  return bindtb
}

export const searchCondi = [
  {
    id: 1,
    text: $t('integration.trunk_number'),
    type: 'input',
    paramsName: 'name',
    isChooze: true
  },
  {
    id: 2,
    text: $t('integration.relay_type'),
    type: 'select',
    paramsName: 'type',
    isChooze: false,
    selectParam: []
  },
  {
    id: 3,
    text: $t('integration.framework'),
    type: 'input',
    paramsName: 'sceneId',
    isChooze: false
  },
  {
    id: 4,
    text: $t('integration.mount_'),
    type: 'input',
    paramsName: 'carrierName',
    isChooze: false
  }
]
